// @ts-nocheck
// VENDORED from mobile: app/utilities/FirebaseHelper.ts — do not edit here; edit the mobile file and run scripts/sync-shared.sh
//Generates a random identifier to be used for as key for saving items and such
export const randomString = (length: number): string => {
	return Math.round(
		Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)
	)
		.toString(36)
		.slice(1);
};
